// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.styles-module__react-toggle___xmTEh {
  display: inline-block;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.styles-module__react-toggle___xmTEh:hover:not(.styles-module__react-toggle--disabled___IgMkD) .styles-module__react-toggle-track___wzFlz {
  background-color: var(--neutral45, #b3b9be);
}

.styles-module__react-toggle-screenreader-only___vnuEA {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.styles-module__react-toggle--disabled___IgMkD {
  cursor: not-allowed;
  opacity: 0.5;
  transition: opacity 0.25s;
}

.styles-module__react-toggle--focus___UbVXc {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}

.styles-module__react-toggle-track___wzFlz {
  width: 50px;
  height: 24px;
  padding: 0;
  border-radius: 30px;
  background-color: var(--neutral15);
  transition: all 0.2s ease;
}
.styles-module__react-toggle-track--profile-edit___rknNd {
  width: 64px;
  height: 32px;
}
.styles-module__react-toggle-track--sftp-test-mode___XnL6A {
  width: 36px;
  height: 20px;
  background-color: var(--blue300, #7c53a5) !important;
  border: 1px solid var(--primary600, #4b286d);
}
.styles-module__react-toggle-track--programmes-autoplay___PsOT3 {
  width: 54px;
  height: 32px;
}
.styles-module__react-toggle-track--unchecked-profile-edit___IQTkL {
  background-color: var(--neutral30, #e3e6e8) !important;
}
.styles-module__react-toggle-track--unchecked-sftp-test-mode___J7lOZ {
  background-color: var(--base, #f4f4f7) !important;
  border: 1px solid var(--neutral30, #e3e6e8);
}
.styles-module__react-toggle-track--unchecked-upload-card___rSPPY {
  background-color: var(--surface1, #fff) !important;
  border: 1px solid var(--neutral30, #e3e6e8);
}
.styles-module__react-toggle-track--perks-newsletter-consent___cH82N {
  height: 32px;
  width: 52px;
}
.styles-module__react-toggle-track--unchecked-perks-newsletter-consent___AhrIJ {
  background-color: var(--neutral45, #b3b9be) !important;
}

.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-track--blue___FB6l3 {
  background-color: var(--primary600, #4b286d);
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-track--green___g1VGN {
  background-color: var(--green300, #2b8000);
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-track-check___ssI4V {
  opacity: 1;
  transition: opacity 0.25s ease;
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-track-x___Z4GPU {
  opacity: 0;
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-thumb___p4bjS {
  left: 27px;
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-thumb--profile-edit___MtCw7 {
  left: 37px;
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-thumb--sftp-test-mode___lcers {
  left: 17px;
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-thumb--blue___eKrMx {
  border-color: var(--primary600, #4b286d);
}
.styles-module__react-toggle--checked___jZsQs .styles-module__react-toggle-thumb--green___Ac0lR {
  border-color: var(--green300, #2b8000);
}
.styles-module__react-toggle--checked___jZsQs:hover:not(.styles-module__react-toggle--disabled___IgMkD) .styles-module__react-toggle-track--blue___FB6l3 {
  background-color: var(--primary600, #4b286d);
}
.styles-module__react-toggle--checked___jZsQs:hover:not(.styles-module__react-toggle--disabled___IgMkD) .styles-module__react-toggle-track--green___g1VGN {
  background-color: var(--green300, #2b8000);
}

.styles-module__react-toggle-track-check___ssI4V {
  position: absolute;
  width: 14px;
  height: 10px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  left: 8px;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.styles-module__react-toggle-track-x___Z4GPU {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  right: 10px;
  opacity: 1;
  transition: opacity 0.25s ease;
}

.styles-module__react-toggle-thumb___p4bjS {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 22px;
  height: 22px;
  border: 1px solid var(--neutral15);
  border-radius: 50%;
  background-color: var(--surface1, #fff);
  box-sizing: border-box;
  transition: all 0.25s ease;
}
.styles-module__react-toggle-thumb--profile-edit___MtCw7, .styles-module__react-toggle-thumb--programmes-autoplay___cxSfy {
  top: 3px;
  width: 26px;
  height: 26px;
}
.styles-module__react-toggle-thumb--sftp-test-mode___lcers {
  top: 1px;
  width: 18px;
  height: 18px;
  border: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/inputs/toggle-comp/styles.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAMF;AALE;EACE,2CAAA;AAOJ;;AAJA;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAOF;;AALA;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAQF;;AANA;ECzBI,wCAAA;EACA,mBAAA;ADmCJ;;AARA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,kCAAA;EACA,yBAAA;AAWF;AATE;EACE,WAAA;EACA,YAAA;AAWJ;AARE;EACE,WAAA;EACA,YAAA;EACA,oDAAA;EACA,4CAAA;AAUJ;AAPE;EACE,WAAA;EACA,YAAA;AASJ;AANE;EACE,sDAAA;AAQJ;AALE;EACE,iDAAA;EACA,2CAAA;AAOJ;AAJE;EACE,kDAAA;EACA,2CAAA;AAMJ;AAHE;EACE,YAAA;EACA,WAAA;AAKJ;AAFE;EACE,sDAAA;AAIJ;;AACI;EACE,4CAAA;AAEN;AACI;EACE,0CAAA;AACN;AAGE;EACE,UAAA;EACA,8BAAA;AADJ;AAGE;EACE,UAAA;AADJ;AAGE;EACE,UAAA;AADJ;AAGI;EACE,UAAA;AADN;AAII;EACE,UAAA;AAFN;AAKI;EACE,wCAAA;AAHN;AAMI;EACE,sCAAA;AAJN;AAQI;EACE,4CAAA;AANN;AASI;EACE,0CAAA;AAPN;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AARF;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;AAPF;;AASA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,uCAAA;EACA,sBAAA;EACA,0BAAA;AANF;AAQE;EAEE,QAAA;EACA,WAAA;EACA,YAAA;AAPJ;AAUE;EACE,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AARJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils';\n\n.react-toggle {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n  user-select: none;\n  &:hover:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: color(neutral45);\n  }\n}\n.react-toggle-screenreader-only {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n.react-toggle--disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  transition: opacity 0.25s;\n}\n.react-toggle--focus {\n  @include focus-outline($applyDirectly: true);\n}\n.react-toggle-track {\n  width: 50px;\n  height: 24px;\n  padding: 0;\n  border-radius: 30px;\n  background-color: color(neutral15);\n  transition: all 0.2s ease;\n\n  &--profile-edit {\n    width: 64px;\n    height: 32px;\n  }\n\n  &--sftp-test-mode {\n    width: 36px;\n    height: 20px;\n    background-color: color(blue300) !important;\n    border: 1px solid color(primary600);\n  }\n\n  &--programmes-autoplay {\n    width: 54px;\n    height: 32px;\n  }\n\n  &--unchecked-profile-edit {\n    background-color: color(neutral30) !important;\n  }\n\n  &--unchecked-sftp-test-mode {\n    background-color: color(base) !important;\n    border: 1px solid color(neutral30);\n  }\n\n  &--unchecked-upload-card {\n    background-color: color(surface1) !important;\n    border: 1px solid color(neutral30);\n  }\n\n  &--perks-newsletter-consent {\n    height: 32px;\n    width: 52px;\n  }\n\n  &--unchecked-perks-newsletter-consent {\n    background-color: color(neutral45) !important;\n  }\n}\n.react-toggle--checked {\n  .react-toggle-track {\n    &--blue {\n      background-color: color(primary600);\n    }\n\n    &--green {\n      background-color: color(green300);\n    }\n  }\n\n  .react-toggle-track-check {\n    opacity: 1;\n    transition: opacity 0.25s ease;\n  }\n  .react-toggle-track-x {\n    opacity: 0;\n  }\n  .react-toggle-thumb {\n    left: 27px;\n\n    &--profile-edit {\n      left: 37px;\n    }\n\n    &--sftp-test-mode {\n      left: 17px;\n    }\n\n    &--blue {\n      border-color: color(primary600);\n    }\n\n    &--green {\n      border-color: color(green300);\n    }\n  }\n  &:hover:not(.react-toggle--disabled) .react-toggle-track {\n    &--blue {\n      background-color: color(primary600);\n    }\n\n    &--green {\n      background-color: color(green300);\n    }\n  }\n}\n.react-toggle-track-check {\n  position: absolute;\n  width: 14px;\n  height: 10px;\n  top: 0;\n  bottom: 0;\n  margin-top: auto;\n  margin-bottom: auto;\n  line-height: 0;\n  left: 8px;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n.react-toggle-track-x {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  top: 0;\n  bottom: 0;\n  margin-top: auto;\n  margin-bottom: auto;\n  line-height: 0;\n  right: 10px;\n  opacity: 1;\n  transition: opacity 0.25s ease;\n}\n.react-toggle-thumb {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 22px;\n  height: 22px;\n  border: 1px solid color(neutral15);\n  border-radius: 50%;\n  background-color: color(surface1);\n  box-sizing: border-box;\n  transition: all 0.25s ease;\n\n  &--profile-edit,\n  &--programmes-autoplay {\n    top: 3px;\n    width: 26px;\n    height: 26px;\n  }\n\n  &--sftp-test-mode {\n    top: 1px;\n    width: 18px;\n    height: 18px;\n    border: none;\n  }\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"react-toggle": `styles-module__react-toggle___xmTEh`,
	"react-toggle--disabled": `styles-module__react-toggle--disabled___IgMkD`,
	"react-toggle-track": `styles-module__react-toggle-track___wzFlz`,
	"react-toggle-screenreader-only": `styles-module__react-toggle-screenreader-only___vnuEA`,
	"react-toggle--focus": `styles-module__react-toggle--focus___UbVXc`,
	"react-toggle-track--profile-edit": `styles-module__react-toggle-track--profile-edit___rknNd`,
	"react-toggle-track--sftp-test-mode": `styles-module__react-toggle-track--sftp-test-mode___XnL6A`,
	"react-toggle-track--programmes-autoplay": `styles-module__react-toggle-track--programmes-autoplay___PsOT3`,
	"react-toggle-track--unchecked-profile-edit": `styles-module__react-toggle-track--unchecked-profile-edit___IQTkL`,
	"react-toggle-track--unchecked-sftp-test-mode": `styles-module__react-toggle-track--unchecked-sftp-test-mode___J7lOZ`,
	"react-toggle-track--unchecked-upload-card": `styles-module__react-toggle-track--unchecked-upload-card___rSPPY`,
	"react-toggle-track--perks-newsletter-consent": `styles-module__react-toggle-track--perks-newsletter-consent___cH82N`,
	"react-toggle-track--unchecked-perks-newsletter-consent": `styles-module__react-toggle-track--unchecked-perks-newsletter-consent___AhrIJ`,
	"react-toggle--checked": `styles-module__react-toggle--checked___jZsQs`,
	"react-toggle-track--blue": `styles-module__react-toggle-track--blue___FB6l3`,
	"react-toggle-track--green": `styles-module__react-toggle-track--green___g1VGN`,
	"react-toggle-track-check": `styles-module__react-toggle-track-check___ssI4V`,
	"react-toggle-track-x": `styles-module__react-toggle-track-x___Z4GPU`,
	"react-toggle-thumb": `styles-module__react-toggle-thumb___p4bjS`,
	"react-toggle-thumb--profile-edit": `styles-module__react-toggle-thumb--profile-edit___MtCw7`,
	"react-toggle-thumb--sftp-test-mode": `styles-module__react-toggle-thumb--sftp-test-mode___lcers`,
	"react-toggle-thumb--blue": `styles-module__react-toggle-thumb--blue___eKrMx`,
	"react-toggle-thumb--green": `styles-module__react-toggle-thumb--green___Ac0lR`,
	"react-toggle-thumb--programmes-autoplay": `styles-module__react-toggle-thumb--programmes-autoplay___cxSfy`
};
export default ___CSS_LOADER_EXPORT___;
